(function () {
  const SECTION_SELECTOR = '[data-pl-section]';

  function initSection(root) {
    if (!root) return;

    /* ==========================================================
       PROTOCOL TABS
       ========================================================== */

    const tabs = root.querySelectorAll('[data-pl-tab]');
    const panels = root.querySelectorAll('[data-pl-panel]');

    tabs.forEach(function (tab) {
      tab.setAttribute('role', 'tab');

      const isActive = tab.classList.contains('pl-tab-on');

      tab.setAttribute(
        'aria-selected',
        isActive ? 'true' : 'false'
      );
    });

    /* ==========================================================
       FAQ
       ========================================================== */

    const faqButtons = root.querySelectorAll('[data-pl-faq]');

    faqButtons.forEach(function (button) {
      const isOpen =
        button.getAttribute('aria-expanded') === 'true';

      const answer = button
        .closest('.pl-qa')
        ?.querySelector('.pl-a');

      const sign = button.querySelector('.pl-sign');

      if (answer) {
        answer.hidden = !isOpen;
      }

      if (sign) {
        sign.textContent = isOpen ? '–' : '+';
      }
    });
  }


  /* ==========================================================
     GLOBAL CLICK HANDLER
     Uses event delegation so it also works when Shopify
     reloads the section inside the theme editor.
     ========================================================== */

  document.addEventListener('click', function (event) {

    /* --------------------------
       Protocol tab click
       -------------------------- */

    const clickedTab = event.target.closest('[data-pl-tab]');

    if (clickedTab) {
      const root = clickedTab.closest(SECTION_SELECTOR);

      if (!root) return;

      event.preventDefault();

      const selectedPanel =
        clickedTab.getAttribute('data-pl-tab');

      const tabs =
        root.querySelectorAll('[data-pl-tab]');

      const panels =
        root.querySelectorAll('[data-pl-panel]');

      tabs.forEach(function (tab) {
        const active = tab === clickedTab;

        tab.classList.toggle(
          'pl-tab-on',
          active
        );

        tab.setAttribute(
          'aria-selected',
          active ? 'true' : 'false'
        );
      });

      panels.forEach(function (panel) {
        const panelName =
          panel.getAttribute('data-pl-panel');

        panel.hidden =
          panelName !== selectedPanel;
      });

      return;
    }


    /* --------------------------
       FAQ accordion click
       -------------------------- */

    const clickedQuestion =
      event.target.closest('[data-pl-faq]');

    if (clickedQuestion) {
      const root =
        clickedQuestion.closest(SECTION_SELECTOR);

      if (!root) return;

      event.preventDefault();

      const currentlyOpen =
        clickedQuestion.getAttribute(
          'aria-expanded'
        ) === 'true';

      const faqButtons =
        root.querySelectorAll('[data-pl-faq]');

      faqButtons.forEach(function (button) {
        const shouldOpen =
          button === clickedQuestion &&
          !currentlyOpen;

        button.setAttribute(
          'aria-expanded',
          shouldOpen ? 'true' : 'false'
        );

        const wrapper =
          button.closest('.pl-qa');

        const answer =
          wrapper?.querySelector('.pl-a');

        const sign =
          button.querySelector('.pl-sign');

        if (answer) {
          answer.hidden = !shouldOpen;
        }

        if (sign) {
          sign.textContent =
            shouldOpen ? '–' : '+';
        }
      });

      return;
    }
  });


  /* ==========================================================
     POWERFUL FORM AUTO HEIGHT
     ========================================================== */

  window.addEventListener(
    'message',
    function (event) {

      if (
        typeof event.origin !== 'string' ||
        !event.origin.includes(
          'powerfulform.com'
        )
      ) {
        return;
      }

      const data = event.data;

      const rawHeight =
        typeof data === 'number'
          ? data
          : data &&
            (
              data.height ||
              data.frameHeight
            );

      const height =
        parseInt(rawHeight, 10);

      if (
        !height ||
        height < 200 ||
        height > 6000
      ) {
        return;
      }

      document
        .querySelectorAll(
          SECTION_SELECTOR +
          ' .pl-formcard iframe'
        )
        .forEach(function (frame) {

          if (
            frame.contentWindow ===
            event.source
          ) {
            frame.style.height =
              height + 'px';
          }

        });
    }
  );


  /* ==========================================================
     INITIAL LOAD
     ========================================================== */

  function initAll(scope) {
    scope = scope || document;

    if (
      scope.matches &&
      scope.matches(SECTION_SELECTOR)
    ) {
      initSection(scope);
    }

    if (scope.querySelectorAll) {
      scope
        .querySelectorAll(
          SECTION_SELECTOR
        )
        .forEach(function (section) {
          initSection(section);
        });
    }
  }


  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        initAll(document);
      }
    );
  } else {
    initAll(document);
  }


  /* ==========================================================
     SHOPIFY THEME EDITOR SUPPORT
     ========================================================== */

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      initAll(event.target);
    }
  );

})();